import React from 'react';

import { getModalToShow, Product, type StorageAdapter, UpgradeModalComponent } from '../../utils';
import { ConfluenceStandardOfferAIModal } from '../ConfluenceStandardOfferAIModal';
import { ConfluenceStandardOfferCalendarModal } from '../ConfluenceStandardOfferCalendarModal';

export const ConfluenceUpgradeFreePoolExperimentModalPreUpgrade = ({
	storageAdapter,
	experienceUrl,
	analyticsAttributes,
}: {
	analyticsAttributes: Record<string, any>;
	experienceUrl: string;
	storageAdapter: StorageAdapter;
}) => {
	// If there is an issue fetching the experience url, do not render the modal
	if (!experienceUrl) {
		return null;
	}

	// Determine which modal to show
	const modalToShow = getModalToShow(storageAdapter, Product.Confluence);

	// Render the appropriate modal component
	switch (modalToShow) {
		case UpgradeModalComponent.ConfluenceStandardOfferAIModal:
			return (
				<ConfluenceStandardOfferAIModal
					analyticsAttributes={analyticsAttributes}
					experienceUrl={experienceUrl}
					storageAdapter={storageAdapter}
				/>
			);
		case UpgradeModalComponent.ConfluenceStandardOfferCalendarModal:
			return (
				<ConfluenceStandardOfferCalendarModal
					analyticsAttributes={analyticsAttributes}
					experienceUrl={experienceUrl}
					storageAdapter={storageAdapter}
				/>
			);
		case UpgradeModalComponent.None:
		default:
			return null;
	}
};
